// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PlaceCallSuccessPopUp {
    min-width: 250px;
    min-height: 170px;
    text-align: center;
}
.PlaceCallSuccessPopUpLogo SVG {
    width: 106.81px;
    height: 106.81px;
}
.PlaceCallSuccessPopUpMsg {
    margin-top: 20px;
    font-size: 20px;
}
.PlaceCallSuccessPopUpBtn {
    top: 415px;
    left: 543px;
    width: 281px;
    height: 32px;
    margin-bottom: 24px;
    background-color: #2d6bff;
    color: white;
    font-weight: bold;
    font-size: 12px;
    cursor: pointer;
    cursor: pointer;
}
.PlaceCallSuccessPopUpBtn:hover {
    background-color: #28a1ec;
}
.service-request-modal-Inprocess--alert {
    width: 350px;
    min-height: 170px;
    text-align: center;
    background-color: #fff;
}
.service-request-modal-Inprocess--alert header {
    font-size: 1rem;
    margin-bottom: 32px;
}
.service-request-modal-Inprocess--alert header.error-header h3 {
    line-height: 1.25;
    margin-top: 11px;
    font-size: 0.75rem;
    color: #eb1616;
}
p {
    margin-top: 0;
    margin-bottom: 1rem;
}
.service-request-modal-Inprocess--alert p {
    line-height: 1.25;
    margin-bottom: 32px;
    font-size: 0.98rem;
    padding: 0 16px;
}
.service-request-modal-Inprocess--alert-button {
    top: 415px;
    left: 543px;
    width: 281px;
    height: 32px;
    margin-bottom: 24px;
    background-color: #2d6bff;
    color: white;
    font-weight: bold;
    font-size: 12px;
    cursor: pointer;
}
.service-request-modal-Inprocess--alert-button:hover {
    background-color: transparent;
    color: #000;
  }
  .light .bt-spinner {
    width: 24px;
      height: 24px;
      border-radius: 50%;
      background-color: transparent;
      border: 3px solid #ddd5d500;
      border-top-color: #03142b;
      border-left-color: #03142b;
      border-bottom-color: #03142b;
      animation: 1s spin linear infinite;
  }
  .light .spinnerdiv {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding-bottom:50vh ;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    bottom: 0;
    right: 0;
    background: #fff;
  }
  .bt-spinner {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: transparent;
    border: 4px solid #ddd5d500;
    border-top-color: rgb(197 192 192 / 41%);
    border-left-color: rgb(197 192 192 / 41%);
    border-bottom-color: rgb(197 192 192 / 41%);
    border-right-color: rgb(37 132 169);
    animation: 1s spin linear infinite;
  }
  .spinnerdiv {
    padding: 30px 0;
    align-items: center;
    display: flex;
    justify-content: center;
    /* position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding-bottom:50vh ;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    bottom: 0;
    right: 0; */
    /* background:  #021125; */
  }`, "",{"version":3,"sources":["webpack://./src/components/InProccessPopup.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;AACnB;AACA;IACI,6BAA6B;IAC7B,WAAW;EACb;EACA;IACE,WAAW;MACT,YAAY;MACZ,kBAAkB;MAClB,6BAA6B;MAC7B,2BAA2B;MAC3B,yBAAyB;MACzB,0BAA0B;MAC1B,4BAA4B;MAC5B,kCAAkC;EACtC;EACA;IACE,eAAe;IACf,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;IAC3B,wCAAwC;IACxC,yCAAyC;IACzC,2CAA2C;IAC3C,mCAAmC;IACnC,kCAAkC;EACpC;EACA;IACE,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB;;;;;;;;;;;eAWW;IACX,0BAA0B;EAC5B","sourcesContent":[".PlaceCallSuccessPopUp {\r\n    min-width: 250px;\r\n    min-height: 170px;\r\n    text-align: center;\r\n}\r\n.PlaceCallSuccessPopUpLogo SVG {\r\n    width: 106.81px;\r\n    height: 106.81px;\r\n}\r\n.PlaceCallSuccessPopUpMsg {\r\n    margin-top: 20px;\r\n    font-size: 20px;\r\n}\r\n.PlaceCallSuccessPopUpBtn {\r\n    top: 415px;\r\n    left: 543px;\r\n    width: 281px;\r\n    height: 32px;\r\n    margin-bottom: 24px;\r\n    background-color: #2d6bff;\r\n    color: white;\r\n    font-weight: bold;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n    cursor: pointer;\r\n}\r\n.PlaceCallSuccessPopUpBtn:hover {\r\n    background-color: #28a1ec;\r\n}\r\n.service-request-modal-Inprocess--alert {\r\n    width: 350px;\r\n    min-height: 170px;\r\n    text-align: center;\r\n    background-color: #fff;\r\n}\r\n.service-request-modal-Inprocess--alert header {\r\n    font-size: 1rem;\r\n    margin-bottom: 32px;\r\n}\r\n.service-request-modal-Inprocess--alert header.error-header h3 {\r\n    line-height: 1.25;\r\n    margin-top: 11px;\r\n    font-size: 0.75rem;\r\n    color: #eb1616;\r\n}\r\np {\r\n    margin-top: 0;\r\n    margin-bottom: 1rem;\r\n}\r\n.service-request-modal-Inprocess--alert p {\r\n    line-height: 1.25;\r\n    margin-bottom: 32px;\r\n    font-size: 0.98rem;\r\n    padding: 0 16px;\r\n}\r\n.service-request-modal-Inprocess--alert-button {\r\n    top: 415px;\r\n    left: 543px;\r\n    width: 281px;\r\n    height: 32px;\r\n    margin-bottom: 24px;\r\n    background-color: #2d6bff;\r\n    color: white;\r\n    font-weight: bold;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n}\r\n.service-request-modal-Inprocess--alert-button:hover {\r\n    background-color: transparent;\r\n    color: #000;\r\n  }\r\n  .light .bt-spinner {\r\n    width: 24px;\r\n      height: 24px;\r\n      border-radius: 50%;\r\n      background-color: transparent;\r\n      border: 3px solid #ddd5d500;\r\n      border-top-color: #03142b;\r\n      border-left-color: #03142b;\r\n      border-bottom-color: #03142b;\r\n      animation: 1s spin linear infinite;\r\n  }\r\n  .light .spinnerdiv {\r\n    position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    padding-bottom:50vh ;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 100;\r\n    bottom: 0;\r\n    right: 0;\r\n    background: #fff;\r\n  }\r\n  .bt-spinner {\r\n    width: 32px;\r\n    height: 32px;\r\n    border-radius: 50%;\r\n    background-color: transparent;\r\n    border: 4px solid #ddd5d500;\r\n    border-top-color: rgb(197 192 192 / 41%);\r\n    border-left-color: rgb(197 192 192 / 41%);\r\n    border-bottom-color: rgb(197 192 192 / 41%);\r\n    border-right-color: rgb(37 132 169);\r\n    animation: 1s spin linear infinite;\r\n  }\r\n  .spinnerdiv {\r\n    padding: 30px 0;\r\n    align-items: center;\r\n    display: flex;\r\n    justify-content: center;\r\n    /* position: fixed;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    padding-bottom:50vh ;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 100;\r\n    bottom: 0;\r\n    right: 0; */\r\n    /* background:  #021125; */\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
